/**
 * STEP — currency config store.
 * Loads the tenant's base-currency display symbol (single source of truth from
 * finance.CurrencySettings) once after auth, and mirrors it into lib/currency
 * so the app-wide synchronous formatters pick it up.
 */
import { create } from "zustand";
import { getCurrencySettings } from "@/api/finance";
import { setBaseSymbol } from "@/lib/currency";

interface CurrencyState {
  symbol: string;
  baseCurrency: string;
  loaded: boolean;
  loadCurrency: () => Promise<void>;
}

export const useCurrencyStore = create<CurrencyState>((set, get) => ({
  symbol: "so'm",
  baseCurrency: "UZS",
  loaded: false,
  loadCurrency: async () => {
    if (get().loaded) return;
    try {
      const res = await getCurrencySettings();
      const cfg = res.data.data;
      setBaseSymbol(cfg.display_symbol);
      set({
        symbol: cfg.display_symbol || "so'm",
        baseCurrency: cfg.base_currency || "UZS",
        loaded: true,
      });
    } catch {
      // keep defaults; will retry on next mount
    }
  },
}));
